<script lang="ts">

    import { pictureUrlFactory } from "../../Services";

    export let id: string;

    $: url = pictureUrlFactory.getPictureUrl(id);

</script>

<img src={url} alt="">
